// extracted by mini-css-extract-plugin
module.exports = {"root":"logoBottom_root__2sHHp","loader":"logoBottom_loader__UMgdQ"};